// Small line icons for the integrator benefit tiles. 24×24 grid, stroke only.
type P = { size?: number };
const base = (size: number) => ({
  width: size,
  height: size,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.8,
  strokeLinecap: "round" as const,
  strokeLinejoin: "round" as const,
  "aria-hidden": true,
});

export const BenefitIcon = {
  // Fewer code hours: code brackets
  Code: ({ size = 22 }: P) => (
    <svg {...base(size)}>
      <path d="M8 6l-5 6 5 6M16 6l5 6-5 6M14 4l-4 16" />
    </svg>
  ),
  // Time-aware: clock
  Clock: ({ size = 22 }: P) => (
    <svg {...base(size)}>
      <circle cx="12" cy="12" r="8.5" />
      <path d="M12 7.5V12l3 2" />
    </svg>
  ),
  // No cloud line item: cloud, struck through
  CloudOff: ({ size = 22 }: P) => (
    <svg {...base(size)}>
      <path d="M7 18a4 4 0 0 1-.6-7.95A5.5 5.5 0 0 1 17 8.5a3.8 3.8 0 0 1 2.2 6.9" />
      <path d="M8 18h9" />
      <path d="M4 4l16 16" />
    </svg>
  ),
  // Proven before go-live: shield with check
  Shield: ({ size = 22 }: P) => (
    <svg {...base(size)}>
      <path d="M12 3l7 3v5.5c0 4.4-3 7.8-7 9.5-4-1.7-7-5.1-7-9.5V6z" />
      <path d="M9 12l2 2 4-4" />
    </svg>
  ),
  // Author: pen writing a line
  Pen: ({ size = 22 }: P) => (
    <svg {...base(size)}>
      <path d="M4 20h4l10.5-10.5a2.1 2.1 0 0 0-3-3L5 17z" />
      <path d="M13.5 8.5l3 3M12 20h8" />
    </svg>
  ),
  // Test: flask
  Flask: ({ size = 22 }: P) => (
    <svg {...base(size)}>
      <path d="M9 3h6M10 3v6l-5.5 9a2 2 0 0 0 1.7 3h11.6a2 2 0 0 0 1.7-3L14 9V3" />
      <path d="M7.5 15h9" />
    </svg>
  ),
  // Deploy: rocket
  Rocket: ({ size = 22 }: P) => (
    <svg {...base(size)}>
      <path d="M14 4c3 0 6 3 6 6-2 4-5 7-9 9l-1-3-3-1c2-4 5-7 7-11z" />
      <path d="M8 14l-3 1 1-3M7 17l-3 3" />
      <circle cx="15" cy="9" r="1.2" />
    </svg>
  ),
  // Scales to the whole plant: stacked layers
  Layers: ({ size = 22 }: P) => (
    <svg {...base(size)}>
      <path d="M12 4l8 4-8 4-8-4z" />
      <path d="M4 12l8 4 8-4M4 16l8 4 8-4" />
    </svg>
  ),
};
